import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

class Footer extends React.Component {

  render() {
    if (!this.props.authorized) return null

    if (this.props.url === 'btf')
      return (
        <footer id="footer" className="footer-section">
          <div className="container">
            <div className="footer-content">
              <div className="row">
                <div className="col-xl-4 col-lg-4 mb-50">
                  <div className="footer-widget" style={{ textAlign: 'center' }}>

                    <div className="footer-text">
                      <p>CONTACT</p><br />
                      <p>Groupe BTF</p>
                      <p>38 avenue Marcellin Maurel</p>
                      <p>06140 Vence</p><br />
                      <p>+(33)4 89 24 13 90</p>
                      <p><Link to="mailto://contact@cartecarburantbtf.fr" >contact@cartecarburantbtf.fr</Link></p>
                      <p>Lundi-Vendredi : 8h30 - 17h30</p>
                    </div>

                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 footer-column">
                  <div className="service-widget footer-widget">
                    <div className="footer-logo" style={{ textAlign: 'center' }}>

                      <img src="assets/images/mobilite_couleur_bg_fonce@4x.png" alt="logo" />

                    </div>

                    <div className="footer-text" style={{ textAlign: 'center' }}>
                      <p>Copyrigth 2022 &#xA9; Tous droits reservés </p><br />
                      <p>Mention Légales et Politique de confidentialité</p>

                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-6 mb-50">
                  <div className="contact-widget footer-widget">
                    <div className="footer-widget-heading" style={{ textAlign: 'center' }}>
                      <h3>Contacts</h3>
                    </div>
                    <div className="footer-text" style={{ textAlign: 'center' }}>
                      <Link to="https://groupebtf.fr/" target="_blank" >Nos Services</Link><br />


                      <Link to="mailto://contact@cartecarburantbtf.fr" >Nous Contacter</Link><br />
                    </div>
                  </div>
                  {(!this.props.parrain.startsWith('SYM')) ?
                    <div className="footer-widget">
                      <div className="footer-widget-heading" style={{ textAlign: 'center' }}>
                        <h3>Faites des économies</h3>
                      </div>
                      <div className="footer-text" style={{ textAlign: 'center' }}>
                        <Link to='https://adherents.reducbox.com/login' target='_blank' >Reducbox</Link>{' '}
                        <Link
                          to={"https://reducpro.fr/?token=" + jwtDecode(this.props.JWTToken).ssoreducpro + "&service=sso&pclient=reducpro&pkclient=1D2y4edYet5ddYZedrg1"}
                          target='_blank'
                        >Reducpro</Link>
                      </div>
                    </div>

                    : null
                  }
                  <div className="footer-widget">
                    <div className="footer-widget-heading" style={{ textAlign: 'center' }}>
                      <h3>Suivez nous</h3>
                    </div>
                    <div className="footer-social-icon" style={{ textAlign: 'center' }}>
                      <a href="https://www.linkedin.com/company/groupe-btf/" rel="noreferrer" target="_blank"><i className="bi bi-linkedin"></i></a>
                    </div>
                  </div>
                

              </div>
            </div>

          </div>
        </div>
        </footer >
      )

    if (this.props.url === 'autogestion')
      return (
        <footer id="footer" className="footer-section">
          <div className="container">
            <div className="footer-content">
              <div className="row">
                <div className="col-xl-4 col-lg-4 mb-50">
                  <div className="footer-widget" style={{ textAlign: 'center' }}>

                    <div className="footer-text">
                      <p></p>
                      <p>AUTO GESTION</p>
                      <p>3, rue des Pins</p>
                      <p>38100 Grenoble</p><br />
                      <p>04 38 12 38 12</p>
                    </div>

                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 footer-column">
                  <div className="service-widget footer-widget">
                    <div className="footer-logo" style={{ textAlign: 'center' }}>

                      <img src={this.props.apiUrl.replace('espaceClient', 'public/ImageService/image/EspCliMainLogo?nocache=' + Date.now())} alt="logo" />

                    </div>

                    <div className="footer-text" style={{ textAlign: 'center' }}>
                      <p>Copyrigth 2022 &#xA9; Tous droits reservés </p><br />
                      <p>Mention Légales et Politique de confidentialité</p>

                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-6 mb-50">
                  <div className="contact-widget footer-widget">
                    <div className="footer-widget-heading" style={{ textAlign: 'center' }}>
                      <h3>Contacts</h3>
                    </div>
                    <div className="footer-text" style={{ textAlign: 'center' }}>
                      <Link to="https://www.auto-gestion.fr/" target="_blank" >Nos Services</Link><br />

                      <Link to="mailto://contact@auto-gestion.fr" >Nous Contacter</Link><br />
                    </div>
                  </div>
                  {/*
                    <div className="footer-widget">
                      <div className="footer-social-icon" style={{ textAlign: 'center' }}>
                        <span>Suivez nous</span>
                        <a href="https://www.linkedin.com/company/groupe-btf/" rel="noreferrer" target="_blank"><i className="bi bi-linkedin"></i></a>
  
                      </div>
                    </div>
 */ }
                </div>
              </div>

            </div>
          </div>
        </footer>
      )
  }
}


const mapStateToProps = (state) => {
  return ({
    serverConfigLoaded: state.server.initialized,
    authorized: state.authentication.authorized,
    clients: state.authentication.clients,
    currentClient: state.authentication.currentClient,
    contentHeight: state.app.contentHeight,
    url: state.app.url,
    apiUrl: state.server.apiUrl,
    parrain: state.app.parrain,
    JWTToken: state.authentication.JWTToken,
  })
}

Footer.propTypes = {
  dispatch: PropTypes.func,
  location: PropTypes.object,
  authorized: PropTypes.bool,
  serverConfigLoaded: PropTypes.bool,
  clients: PropTypes.array,
  currentClient: PropTypes.object,
  contentHeight: PropTypes.number,
  apiUrl: PropTypes.string,
  JWTToken: PropTypes.string,
};

export default connect(mapStateToProps)(Footer);